import { Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'

import {
  getCurrenciesAvailable,
  getDefaultCurrency
} from '../../helpers/userData'
import { Currency } from '../../types/currency'
import useStyles from './CustomSelectCurrency.styles'

interface CustomSelectCurrencyProps {
  onChange: (value: Currency) => void
}

const CustomSelectCurrency: React.FC<CustomSelectCurrencyProps> = ({
  onChange
}) => {
  const [currencies, setCurrencies] = useState<Currency[]>(() => {
    const allCurrencies = getCurrenciesAvailable()
    const defaultCurrency = getDefaultCurrency()

    // Filter out the default currency from the list
    const filteredCurrencies = allCurrencies.filter(
      (c) => c !== defaultCurrency // or other unique property
    )

    // Put default currency at the front
    return [defaultCurrency, ...filteredCurrencies]
  })

  const [isEnable, setisEnable] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    onChange(currencies[0])
  }, [currencies])

  return (
    <div
      className={[classes.root, isEnable ? classes.rootEnabled : ''].join(' ')}
      onMouseEnter={() => setisEnable(true)}
      onMouseLeave={() => setisEnable(false)}
      onFocus={() => {}}>
      <div className={classes.itemsContainer}>
        {currencies.map((item, index) => (
          <div
            key={item}
            className={index === 0 ? classes.itemSelected : classes.item}
            onClick={() => {
              if (index !== 0) {
                setCurrencies([
                  currencies[index],
                  currencies[0],
                  ...currencies.slice(1, index),
                  ...currencies.slice(index + 1)
                ])
                setisEnable(false)
              }
            }}
            role="presentation">
            <Typography
              variant="h5"
              className={
                index === 0 ? classes.itemTextSelected : classes.itemText
              }>
              {item}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  )
}
export default CustomSelectCurrency
